<template>
    <div
        ref="label"
        @click="openFilters"
        class="clickable root noselect"
        style="min-width: 70px;"
    >
        <div class="d-inline-flex align-content-center">
            <div
                class="caption muted mb-0 secondary-color"
                style="line-height: normal; align-self: end; font-size: 15px;"
            >
                {{ label }}
            </div>
            <b-badge
                v-if="count"
                class="secondary-color light-gray lighten-background align-self-center ml-1"
                >{{ count }}</b-badge
            >
            <BaseIcon class="secondary-color" name="caret-down" size="xs" />
        </div>
        <Paper
            id="filters"
            v-if="showFilters"
            :style="filtersPosition"
            v-on-clickaway="closeFilters"
        >
            <h6
                v-for="option in options"
                :key="option.label"
                :class="[
                    'text-center',
                    'p-3',
                    'h-100',
                    'clickable',
                    'mb-0',
                    'noselect',
                    isSelected(option.value)
                        ? 'secondary darken-on-hover selected'
                        : '',
                ]"
                @click="toggleFilter(option.value)"
            >
                {{ option.label }}
            </h6>
        </Paper>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import Vue from 'vue';
export default {
    mixins: [clickaway],
    name: 'FilterBuilder',
    props: {
        label: String,
        labelValue: String,
        options: Array,
        settings: {
            type: Object,
            default: () => ({}),
        },
        value: Object,
        maxHeight: Number,
        yOffset: {
            type: Number,
            default: undefined,
        },
        /* skal se ut som {  options[valgt].value: 1  } */
    },
    data() {
        return {
            showFilters: false,
            filtersPosition: {
                top: 0,
                left: 0,
            },
        };
    },
    methods: {
        openFilters() {
            // Set position if should show will be set to true
            const boundingRect = this.$refs.label.getBoundingClientRect();
            const maxHeight = (this.maxHeight
              ? window.innerHeight - boundingRect.bottom > this.maxHeight
              : false)
                ? this.maxHeight
                : window.innerHeight - boundingRect.bottom;

            const shouldBePlacedFromTop =
                !this.maxHeight && maxHeight < boundingRect.top - this.yOffset;

            this.filtersPosition = {
                top: shouldBePlacedFromTop
                    ? -boundingRect.top + this.yOffset + 'px'
                    : this.yOffset + 'px',
                left: 0,
                'max-height': shouldBePlacedFromTop
                    ? boundingRect.top - this.yOffset + 'px'
                    : maxHeight + 'px',
            };
            // Toggle show
            this.showFilters = true;
        },
        closeFilters(event) {
            this.showFilters = false;
        },
        toggleFilter(value) {
            if (this.value) {
                if (this.value[this.labelValue][value]) {
                    delete this.value[this.labelValue][value];
                    this.emit({ ...this.value });
                } else {
                    if (this.count != this.settings.limit) {
                        this.value[this.labelValue][value] = 1;
                        this.emit({ ...this.value });
                    } else {
                        this.$interfaces.messageModule.addNewMessage({
                            title: this.$t(
                                'shared.searchModule.filterLimit.title'
                            ),
                            message: this.$t(
                                'shared.searchModule.filterLimit.message'
                            ),
                        });
                    }
                }
            }
            this.$forceUpdate();
        },
        isSelected(value) {
            if (this.value) {
                return this.value[this.labelValue][value] ? true : false;
            } else {
                return {};
            }
        },

        emit(val) {
            this.$emit('update:filter', val);
        },
    },
    mounted() {
        if (this.value && !(this.value[this.labelValue] instanceof Object))
            this.emit({
                ...this.value,
                [this.labelValue]: {},
            });
    },
    computed: {
        count() {
            return this.value
                ? Object.keys(this.value[this.$props.labelValue] || {}).length
                : 0;
        },
    },
};
</script>

<style scoped>
.root {
    position: relative;
}
#filters {
    position: absolute;
    z-index: 999;
    display: flex;
    flex-direction: column;
    background-color: white;

    min-width: calc(100% + 100px);

    overflow-y: auto;
}

.selected {
    color: white !important;
}

@media only screen and (max-width: 600px) {
    #filters {
        min-width: 100%;
    }
}

#filters * {
    white-space: nowrap;
}
</style>
